import { render } from "./ChartDemo.vue?vue&type=template&id=57253e30&scoped=true"
import script from "./ChartDemo.vue?vue&type=script&lang=js"
export * from "./ChartDemo.vue?vue&type=script&lang=js"

import "./ChartDemo.vue?vue&type=style&index=0&id=57253e30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57253e30"]])

export default __exports__